import { rem } from '@mantine/core';
import { GridApi } from 'ag-grid-community';
import { FaultSeveritySelect } from 'components/selects/FaultSeveritySelect';
import useFilterValue, { FilterChangeCallback } from 'components/tables/filters/hooks/use-filter-value';

/**
 * The key of the filter. Must be equal to the column field.
 */
export const FILTER_KEY = 'faultSeverity.faultSeverityId' as const;

/**
 * Parameters of the FaultSeverityFilter component.
 */
export interface FaultSeverityFilterProps {
  api: GridApi;
  onChange: FilterChangeCallback;
}

/**
 * Filter component for the faultSeverity.faultSeverityId column.
 *
 * This filter assumes:
 * - column field is `faultSeverity.faultSeverityId`
 */
export default function FaultSeverityFilter({ api, onChange }: FaultSeverityFilterProps) {
  const [value, setValue] = useFilterValue({ api, filterKey: FILTER_KEY, onChange });

  return (
    <FaultSeveritySelect
      lazyLoad
      clearable
      w="100%"
      size="sm"
      placeholder="Všetky nedostatky"
      value={String(value)}
      onChange={setValue}
      styles={{ dropdown: { minWidth: rem(400) } }}
    />
  );
}
